import { Link } from "react-router-dom";

const Header = ({ currentUser }) => (
  <div className="text-right mb-3">
    <>
      {currentUser.paymentType !== "paypal" &&
        <Link
        to={"/payment-method"}
        className="btn btn-primary mr-2"
      >
        Update Payment Method
      </Link>
      }
      {/*}
      <Link
        to={"/plan"}
        className="btn btn-primary mr-2"
      >
        Change Subscription Plan
      </Link>
*/}
      <Link
        to={"/cancel"}
        className="btn btn-danger"
      >
        Cancel My Subscription
      </Link>
      <Link
        to={"/delete"}
        className="btn btn-danger"
      >
        Remove My Account
      </Link>
    </>
  </div>
)

export default Header;
